import DatePicker from "./datePicker.vue";
export default DatePicker;
